import { render, staticRenderFns } from "./ChangeOrders.vue?vue&type=template&id=ad1e0f8a&scoped=true&"
import script from "./ChangeOrders.vue?vue&type=script&lang=js&"
export * from "./ChangeOrders.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrders.vue?vue&type=style&index=0&id=ad1e0f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1e0f8a",
  null
  
)

export default component.exports